import { render, staticRenderFns } from "./AccountIcon.vue?vue&type=template&id=ef513da2"
import script from "./AccountIcon.vue?vue&type=script&lang=js"
export * from "./AccountIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports